import React, {useState} from 'react';
import axios from 'axios';
import '../config.js';
import { theme, createFormData } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import Progress from '../components/progress.js';
import InvoiceListItem from '../components/invoiceListItem.js';

function ProformaBasicInfo(props){
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState(props.proforma.description);
  const [rate, setRate] = useState(props.proforma.rate);
  const [pax, setPax] = useState(props.proforma.pax);
  const [tax, setTax] = useState(props.proforma.tax);
  const [currency, setCurrency] = useState(props.proforma.currency);
  const [notifySms, setNotifySms] = useState(0);
  const [notifyMail, setNotifyMail] = useState(0);
  
  const handleSubmit = (event) => {
    event.preventDefault();
    if(rate && rate > 0 && pax && pax > 0 && description){
      setLoading(true);
      axios.post(global.config.api_server+'proforma',createFormData({
        description: description,
        rate: rate,
        pax: pax,
        tax: tax,
        currency: currency,
        token: localStorage.getItem("token"),
        id: props.id,
        task: 'edit',
        notifySms: notifySms,
        notifyMail: notifyMail
      })).then(res => {
        setLoading(false);
        if(res.status === 200 && res.data.status === 'success'){
          alertService.success('Proforma updated');
        }else{
          alertService.error(res.data.error);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Some fields are required');
    }
  }

  const handleNotifySms = (event) =>{
    if(event.target.checked){
      setNotifySms(1);
    }else{
      setNotifySms(0);
    }
  }

  const handleNotifyMail = (event) =>{
    if(event.target.checked){
      setNotifyMail(1);
    }else{
      setNotifyMail(0);
    }
  }

  return(
    <div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <button onClick={(e) => handleSubmit(e)} className={'btn btn-icon-split float-right btn-'+theme()}>
            <span className="icon text-white-50">
              <i className="fas fa-save"></i>
            </span>
            <span className="text">Save</span>
          </button>
          <h6 className={'mt-2 font-weight-bold text-'+theme()}>Proforma Invoice Detail</h6>
        </div>
        <div className="card-body">
          <div className="row">
            {loading === true ? (
              <Progress label='Saving' small={true}/>
            ):null}
            <div className="col-md-6">
              <div className="form-group">
                <label>Proforma id</label>
                <input type="text" value={props.proforma.proforma_id} disabled={true} className="form-control"/>
              </div>
              <div className="form-group">
                <label>Currency *</label>
                <select value={currency} name="currency" className="form-control" id="currency" onChange={(e) => setCurrency(e.target.value)}>
                  {global.config.currencies.split(",").map(c =>
                    <option value={c} key={c}>{c}</option>
                  )}
                </select>
              </div>
              <div className="form-group">
                <label>Total amount</label>
                <input type="text" value={props.proforma.amount} disabled={true} className="form-control"/>
              </div>
              <div className="form-group">
                <label>Number of Pax *</label>
                <input type="number" value={pax} name="pax" className="form-control" id="pax" placeholder="Enter pax" onChange={(e) => setPax(e.target.value)}/>
              </div>
              <div className="form-group">
                <label>Rate per pax *</label>
                <input type="number" value={rate} name="rate" className="form-control" id="rate" placeholder="Enter Rate" onChange={(e) => setRate(e.target.value)}/>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Services *</label>
                <textarea className="form-control textarea-xlg" value={description} onChange={(e)=>setDescription(e.target.value)}></textarea>
              </div>
              <div className="form-group">
                <input type="checkbox" onChange={(e) => handleNotifyMail(e)}/> Send Mail &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox" onChange={(e) => handleNotifySms(e)}/> Send SMS
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <hr/>
              <div className="form-group">
                <label><strong>Stats</strong></label>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Updated</label>
                <input type="text" disabled={true} value={props.proforma.updation_date} className="form-control"/>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Created</label>
                <input type="text" disabled={true} value={props.proforma.creation_date} className="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className={'mt-2 font-weight-bold text-'+theme()}>Tax Invoice</h6>
        </div>
        <div className="card-body">
        <div className="table-responsive">
          <div className="row">
            {loading === true ? (
              <Progress label='Loading..' small={true}/>
            ):null}
              <div className="col-sm-12">
                {props.proforma.invoice && props.proforma.invoice.invoice_id ? (
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Tax Invoice Id</th>
                      <th>Client</th>
                      <th>Description</th>
                      <th>Pax</th>
                      <th>Currency</th>
                      <th>Amount</th>
                      <th>Paid</th>
                      <th>Balance</th>
                      <th>Updated On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <InvoiceListItem info={props.proforma.invoice} key={props.proforma.invoice.invoice_id} type="client"/>
                  </tbody>
                </table>
                ): <span>No tax invoice invoice created yet, against this Proforma invocie</span> }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProformaBasicInfo;